const backgroundType = {
    IMAGE: 'Image',
    COLOR: 'Color'
};

export default backgroundType;
